"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils/utils");

require("./Label.less");

var _InputConstants = require("./InputConstants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InputLabel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputLabel, _Component);

  var _super = _createSuper(InputLabel);

  function InputLabel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputLabel);
    _this = _super.call(this, props);
    _this.state = {
      uniqueId: (0, _utils.generateUUID)()
    };
    return _this;
  }
  /* Used to associate label and inputs together htmlFor ADA*/


  (0, _createClass2.default)(InputLabel, [{
    key: "insertId",
    value: function insertId(children) {
      var _this2 = this;

      if (_react.default.Children.count(children) > 0) {
        var firstChild = true;
        return _react.default.Children.map(children, function (child) {
          if (firstChild) {
            firstChild = false;
            return /*#__PURE__*/_react.default.cloneElement(child, {
              id: _this2.state.uniqueId
            });
          }

          return child;
        });
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var displayClass = '';

      if (this.props.display == 'inline') {
        displayClass = 'ui-inline';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(_InputConstants.CLASSES.TYPE.LABEL, " ").concat(displayClass)
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: this.state.uniqueId,
        className: this.props.className
      }, this.props.title), this.insertId(this.props.children));
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        label: _propTypes.default.any.isRequired,
        children: _propTypes.default.node.isRequired,
        display: _propTypes.default.oneOf(['block', 'inline'])
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        className: '',
        display: 'block'
      };
    }
  }]);
  return InputLabel;
}(_react.Component);

exports.default = InputLabel;